module.exports = __webpack_public_path__ + "static/media/Fenix- DEF.d56d737f.png";